
import { SALESREP_ROLE, SURVEYOR_ROLE } from "../constants";
import { navigate } from "../routing/router";
import { getName, getUserRole, isAuthenticated, logout } from "../services/auth";
import { deleteAllClientData } from "../services/db";
import { convertLinksToSPA } from "./alink";
import { showConfirmationModal } from "./confirmation-modal";

export async function renderNav(
  container: HTMLElement): Promise<void> {

    const isUserAuthenticated = isAuthenticated();
    const isLoadedWizward = window.location.pathname.startsWith('/wizard/');

    if(isLoadedWizward) {
      container.innerHTML = '<div id="header-content" class="header-content"></div>';
      return;
    }
    const name = isUserAuthenticated === true ? await getName() : "";
    const logoutText = isUserAuthenticated ? `Logout (${name})` : "Logout";
    const logoutButn = `<button id="logout-btn" class="btn btn-secondary">${logoutText}</button>`;
    const role = isUserAuthenticated === false ? SALESREP_ROLE : getUserRole();
    const appType = role === SURVEYOR_ROLE ? "Surveyor" : "Sales";
    container.innerHTML = `
      <div id="header-content" class="header-content">
        <a href="/"><img src="/assets/logo-white.png" alt="Company Logo" class="navbar-logo" /></a>
        <h1>Walk In Bath - ${appType} Application</h1>
          ${isUserAuthenticated ? logoutButn : '<div style="width:120px;"></div>'}
      </div>
    `;

    
    
    if (isUserAuthenticated) {

      convertLinksToSPA(container);

      const logoutBtn = document.getElementById('logout-btn') as HTMLButtonElement | null;
      if(logoutBtn) {
        logoutBtn.addEventListener('click', async (e) => {
            e.preventDefault();
            
            // Check if user is online or offline
            const isOnline = navigator.onLine;
            
            // Show warning modal
            const message = isOnline 
              ? 'Are you sure you want to logout? Make sure all your work has been saved and synced.'
              : 'You are currently offline. If you logout now, you will need to be online to sign in again.<br /> Any unsynced data will remain on this device. <br />Are you sure you want to logout?';
            
            const result = await showConfirmationModal({
              title: 'Confirm Logout',
              message: message,
              modalType: 'warning',
              buttons: [
                { label: 'Logout', value: 'logout', style: 'danger' },
                { label: 'Cancel', value: 'cancel', style: 'secondary', isDefault: true }
              ]
            });
            
            if (result === 'logout') {
              try {
                console.log('[Logout] User confirmed logout');
                // Logout with server notification if online
                await logout(isOnline);

                //Clear any cached data if needed.
                //This will include images stored in IndexedDB that are not yet synced.
                //Also will include any local DB data in the orders and images tables. 
                //Last_syncs records but the cached options can stay.
                await deleteAllClientData();

                // Redirect to login page
                //window.location.href = '/login';

                navigate("/login");

              } catch (error) {
                console.error('Logout failed:', error);
                // Even if logout fails, redirect to login
                window.location.href = '/login';
              }
            } else {
              console.log('[Logout] User cancelled logout');
            }
        });
      }
    }
}
